import { IntlProvider } from 'react-intl';
import '@formatjs/intl-numberformat/polyfill';
import '@formatjs/intl-numberformat/locale-data/en'; // locale-data for en
import '@formatjs/intl-numberformat/locale-data/ne'; // locale-data for en
import Nepali from '../_lang/ne.json';
import English from '../_lang/en-US.json';

const LanguageWrapper = ({ local, children }) => {
  const messages = local === 'ne' ? Nepali : English;
  const locale = local === 'ne' ? 'en-IN' : 'en-US';
  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  );
};

export default LanguageWrapper;
